<script setup lang="ts">
import { useIdle, useTimestamp } from '@vueuse/core'

const colorMode = useColorMode()
colorMode.preference = 'light'

const { loggedIn, authReady } = useAuth()

const config = useRuntimeConfig().public

const timeOutInactivity = convertStringFormatToMs(config.timeout_inactivity)
const alertBeforeTimeOutInactivity = convertStringFormatToMs(config.alert_before_timeout_inactivity)

const { idle, lastActive } = useIdle(timeOutInactivity)

const now = useTimestamp()

const idledFor = computed(() =>
  Math.floor((now.value - lastActive.value))
)

const beforeIdle = computed(() => alertBeforeTimeOutInactivity - idledFor.value <= 0)

watch(idle, (newData) => {
  if (newData === true) {
    useLogout()
  }
})
</script>

<template>
  <div>
    <!-- Indicateur de chargement pendant l'authentification -->
    <div v-if="!authReady" class="flex items-center justify-center min-h-screen bg-zinc-100">
      <div class="text-center">
        <Loader />
        <p class="mt-4 text-gray-600">
          {{ $t('global.loading') }}
        </p>
      </div>
    </div>

    <!-- App quand auth est prête -->
    <template v-else>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>

      <UNotifications :ui="{ container: 'px-4 sm:px-6 py-6 space-y-3 overflow-y-auto break-words' }" />
      <ModalInactivity v-if="loggedIn === true" :is-open="beforeIdle" />
    </template>
  </div>
</template>
